import { FormattedMessage } from "react-intl";

import { OrganizationTransactionVariant } from "graphql_globals";

type Props = {
  transactionVariant: OrganizationTransactionVariant;
};

export function FormattedTransactionVariant({ transactionVariant }: Props) {
  switch (transactionVariant) {
    case OrganizationTransactionVariant.ESIGN:
      return <FormattedMessage id="ff2e5a37-0269-406f-9262-f19a8760e14b" defaultMessage="eSign" />;
    case OrganizationTransactionVariant.NOTARIZATION:
      return (
        <FormattedMessage id="85d61699-e914-444c-88db-50e8b01104fe" defaultMessage="Notarization" />
      );
    case OrganizationTransactionVariant.PROOF:
      return <FormattedMessage id="037e7b95-1cb6-479e-a645-76dda6040582" defaultMessage="Proof" />;
    case OrganizationTransactionVariant.VERIFICATION_OF_FACT:
      return (
        <FormattedMessage
          id="ff33fc7d-8237-41f0-8ec6-610f9403a169"
          defaultMessage="Verification of fact"
        />
      );
  }
}
